export const styles = {
  container: [
    "max-w-[486px]",
    "w-full",
    "mt-auto",
    "lg:mt-16",
    "xl:ml-24",
    "lg:py-10",
    "lg:px-11",
    "bg-white",
    "lg:text-left",
    "rounded-xl",
    "shadow-lg p-3",
    "pointer-events-auto",
    "text-center",
  ].join(" "),
  title: ["font-bold", "text-xl", "lg:text-4xl"].join(" "),
  subtitle: ["mt-3", "xl:mt-4", "text-base", "lg:text-lg", "text-gray-me"].join(
    " "
  ),
  button: [
    "w-full",
    "py-2",
    "mt-2",
    "lg:mt-7",
    "lg:py-4",
    "text-lg",
    "lg:text-2xl",
    "bg-yellow-me",
    "rounded-full",
  ].join(" "),
};
